$(document).on 'turbolinks:before-visit', ->
  $(document).off 'initialize-feature-test'
  $(document).off 'exercises::watchVideoSegment'
  $(document).off 'exercises::waitForLead'
  $(document).off 'exercises::checkConvertGoal'
  $(document).off 'segmentEnded'

$ ->
  $(document).on 'initialize-feature-test', ->
    if $('.shared-feature-test')[0]

      if $('body').is('.videos-page')
        $nextVideo = $('a.videos-navigation__link--next')
        $(document).trigger 'exercises::setNextVideoPresent',
          next_video_present: $nextVideo.length != 0
        if $nextVideo[0]
          $(document).off 'exercises::watchNextVideo'
          $(document).on 'exercises::watchNextVideo', ->
            $nextVideo[0].click()

  $(document).on 'exercises::watchVideoSegment', (event, data) ->
    window.scrollTo({ top: 0, behavior: 'smooth' })
    if data # jquery event
      videoSegmentStartTime = data.videoSegmentStartTime
      videoSegmentEndTime = data.videoSegmentEndTime
    else # vanilla event
      videoSegmentStartTime = event.originalEvent.detail.videoSegmentStartTime
      videoSegmentEndTime = event.originalEvent.detail.videoSegmentEndTime

    if Sofatutor.player.isNative
      setTimeout( -> $('#player-0').get(0)?.playSegment?(videoSegmentStartTime, videoSegmentEndTime))
    else
      player = videojs?.getPlayers?()['player-0'] || videojs.players['player-0']

      if player
        player?.playSegment?(videoSegmentStartTime, videoSegmentEndTime)

  $(document).on 'exercises::waitForLead', (event, data) ->
    $(document).trigger 'exercises::checkAnswer'

  $(document).on 'exercises::checkConvertGoal', (event, data) ->
    Sofatutor.tracking.convert.trigger('100211113')

  $(document).on 'segmentEnded', ->
    if $('.playing-segment')[0]
      if $('#launchpad-videohint-end')[0]
        $('#launchpad-videohint-end').show()
        $('#sofatutor-videojs-player-0, #player-0').addClass('show-for-medium')

  $(document).trigger 'initialize-feature-test'
